import { useFormContext } from 'react-hook-form';
import { Col, FormGroup, Label } from 'reactstrap';

import { SaveForm } from 'types/pages/audience-builder/shared/save';
import { s } from 'utilities/strings';

const ReadOnlyAudience = () => {
  const { getValues } = useFormContext<SaveForm>();

  return (
    <FormGroup row>
      <Label sm={4}>{s('Site.OrderType')}</Label>
      <Label sm={8}>
        <Col>{getValues('orderType.name') ?? s(['Site.Not', 'Site.Set'])}</Col>
      </Label>
    </FormGroup>
  );
};

export default ReadOnlyAudience;
